module.exports = require("./br-FR.js");